import React, { useMemo, useState } from 'react';
import { IField, TData } from '../../types/forms';
import Form from '../../components/Form/Form';

interface IFormPropTypes {
  fields: Array<IField>;
  handleForm: (data: Partial<TData>) => void;
  formError?: any;
}

const BUTTON_LABELS = {
  EMAIL_STEP: 'Continue with email',
  COMPLETE_STEP: 'Create Account',
} as const;
const NOTE = 'Please note, both email and password fields are case-sensitive.';
const PRE_PAYWALL_NOTE = 'Create an account to view your recommended program.';
const PRE_PAYWALL_PAGE = 'onboarding';

export const CreateAccountForm = ({ fields, handleForm, formError }: Readonly<IFormPropTypes>) => {
  const [visibleFields, setVisibleFields] = useState(() => (fields.length > 0 ? [fields[0]] : []));
  const isEmailStepOnly = visibleFields.length === 1;
  const showPasswordFields = () => setVisibleFields(fields);

  const showPrePaywallNote = useMemo(() => {
    if (document.referrer.includes(PRE_PAYWALL_PAGE)) {
      return true;
    }
    return false;
  }, []);

  return (
    <Form
      title="Create Account"
      fields={visibleFields}
      handleForm={isEmailStepOnly ? showPasswordFields : handleForm}
      formError={formError}
      buttonLabel={isEmailStepOnly ? BUTTON_LABELS.EMAIL_STEP : BUTTON_LABELS.COMPLETE_STEP}
      subTitle={showPrePaywallNote ? PRE_PAYWALL_NOTE : undefined}
    >
      {!isEmailStepOnly && <p className="register-login-note">{NOTE}</p>}
    </Form>
  );
};
